import { render, staticRenderFns } from "./ElCarouselV4.vue?vue&type=template&id=1d77432d"
import script from "./ElCarouselV4.vue?vue&type=script&lang=js"
export * from "./ElCarouselV4.vue?vue&type=script&lang=js"
import style0 from "./ElCarouselV4.vue?vue&type=style&index=0&id=1d77432d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports